if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
		super();

		this.form = this.querySelector('form');
		if (this.form) {
         this.form.querySelector('[name=id]').disabled = false;
		 this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
     	}
   //   this.cartNotification = document.querySelector('cart-notification');
      this.AjaxCart = document.querySelector('ajax-cart');
    }

    onSubmitHandler(evt) {
		evt.preventDefault();
		const submitButton = this.querySelector('[type="submit"]');
		let select_variant = !!submitButton.dataset.selectVariant;

		if (select_variant) {
			let dropdowns =  this.form.querySelector('.custom_variants-dropdown');
			let items =  this.form.querySelectorAll('.custom_variant-item');
				if (dropdowns.classList.contains('custom_variants-dropdown--show')) {
					dropdowns.classList.remove('custom_variants-dropdown--show');
				} else {
					dropdowns.classList.add('custom_variants-dropdown--show');
				}



			items.forEach(item => {
				item.addEventListener('click',(function(event) {
					this.form.querySelector('[name=id]').value = event.target.dataset.id;
					this.addToCart(submitButton);
				}).bind(this))
			})

			window.addEventListener("click", function(event) {
				if (event.target !== dropdowns) {
					dropdowns.classList.remove('custom_variants-dropdown--show');
				}


			});

		} else {
			this.addToCart(submitButton);
		}

	}

    handleErrorMessage(errorMessage = false) {
     this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
     this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

     this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    addToCart(submitButton) {

		if (submitButton.classList.contains('loading')) return;

		this.handleErrorMessage();
		//  this.cartNotification.setActiveElement(document.activeElement);
		//  this.AjaxCart.setActiveElement(document.activeElement);

		submitButton.setAttribute('aria-disabled', true);
		submitButton.classList.add('loading');
		this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

		const config = fetchConfig('javascript');
		config.headers['X-Requested-With'] = 'XMLHttpRequest';
		delete config.headers['Content-Type'];

		const formData = new FormData(this.form);
		formData.append('sections', this.AjaxCart.getSectionsToRender().map((section) => section.id));

		formData.append('sections_url', window.location.pathname);
		config.body = formData;

		fetch(`${routes.cart_add_url}`, config)
			.then((response) => response.json())
			.then((response) => {
				if (response.status) {
					this.handleErrorMessage(response.description);
					return;
				}
				this.AjaxCart.open();
				this.AjaxCart.renderContents(response);

				//   this.cartNotification.renderContents(response);
			})
			.catch((e) => {
				console.error(e);
			})
			.finally(() => {
				submitButton.classList.remove('loading');
				submitButton.removeAttribute('aria-disabled');
				this.querySelector('.loading-overlay__spinner').classList.add('hidden');
			});
	  }
  });
}

